import { Form } from '@unform/web';
import { lighten } from 'polished';
import styled from 'styled-components';

import { COLORS } from 'styles/constants';

interface ReviewVeredictProps {
  selected: boolean;
}

export const Container = styled(Form)`
  width: 50%;

  display: flex;
  flex-direction: column;
  justify-content: center;

  label {
    font-size: 18px;
  }

  @media only screen and (max-width: 700px) {
    width: 85%;
  }
`;

export const DiscardReviewButton = styled.button`
  font-size: 22px;
  color: #fff;
  border: none;
  background: none;

  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }
`;

export const ReviewData = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ReviewVeredictContainer = styled.div``;

export const ReviewVeredict = styled.button<ReviewVeredictProps>`
  margin-left: 10px;
  padding: 10px;

  background: #fff;
  border-radius: 5px;
  color: ${COLORS.primary};
  border: none;
`;

export const SaveReviewButton = styled.button`
  margin-top: 16px;
  padding: 16px;

  background: #fff;
  color: ${COLORS.secondary};
  border: 2px solid #0000;
  border-radius: 5px;

  &:hover {
    color: #fff;
    background: ${lighten(0.22, COLORS.primary)};
    border: 2px solid #fff;
  }
`;
